export enum ActionsEnum {
	Create = 1,
	Update = 2,
	Delete = 3,
}

export interface Action {
	action: ActionsEnum;
}

export interface IError {
	code: number;
	message: string;
}

export type FetchDataResponse<T = any> = {
	data?: T;
	error?: IError;
	contentType?: string | null;
	contentDisposition?: string | null;
};

export type ErrorResponse = {
	error: IError;
};

export type ErrorHandlerFn = (error: ErrorResponse) => ErrorResponse;

export type ResponseWitOutData = FetchDataResponse<null>;
export type ResponseAction = FetchDataResponse<Action>;

export interface AuthKeys {
	apiKey?: string;
	token?: string;
}

export interface BSHttpOptions extends AuthKeys {
	baseUrl: string;
	errorHandler?: ErrorHandlerFn;
}

/** Sink for optional WebSocket delivery diagnostics (`debug` on BSDeliveryWsOptions). */
export type WsDeliveryDebugLogger = (
	message: string,
	...args: unknown[]
) => void;

export interface BSDeliveryWsOptions extends AuthKeys {
	baseUrl: string;
	/** Max entries into retry() per outage before giving up (default 500). */
	maxReconnectCount?: number;
	/**
	 * Rapid phase: base spacing (ms) before exponential backoff; first ~5 minutes after an outage
	 * also use an immediate retry on each drop while reconnectCount is 0. Default 5000 ms.
	 */
	reconnectTime?: number;
	/** After the rapid window: linear waits 1×, 2×, 3× … this many ms (default 5 minutes). */
	reconnectLinearStepMs?: number;
	/**
	 * Verbose reconnect/subscribe/socket lifecycle logs.
	 * `true` → console with prefix `[BigState WS Delivery]`; pass a function to plug into your logger.
	 */
	debug?: boolean | WsDeliveryDebugLogger;
}

export interface GetListRequest {
	pattern?: string;
	next?: number;
}

export type NextType = {
	next: number;
};
